export default __webpack_public_path__ + "propeller.2ca940e5.png";